import React from 'react';
import moment from 'moment';

// @mui
import { TableCell } from '@mui/material';
import { fDateTime } from '../../utils/formatTime';
import GridTruncatedText from '../../sections/@dashboard/grid/GridTruncatedText';

/**
 * `field.sourceFormat` names a value that is not a timestamp: a balance day
 * comes as the number 261022 (YYMMDD), which `new Date` reads as milliseconds.
 */
const toDate = (value, sourceFormat) => {
    if (!sourceFormat) return value;
    const parsed = moment(String(value).padStart(sourceFormat.length, '0'), sourceFormat, true);
    return parsed.isValid() ? parsed.toDate() : null;
};

export default class GridDateCell extends React.Component {
    render() {
        const baseStyle = this.props.styles;
        const { value, field } = this.props;
        const enableTime = field?.enableTime || false;
        const date = value === null || value === undefined || value === ''
            ? null
            : toDate(value, field?.sourceFormat);
        let text = '—';
        if (date) {
            text = enableTime
                ? fDateTime(date, 'd MMM yyyy HH:mm')
                : fDateTime(date, 'd MMM yyyy');
        }
        return (
            <TableCell key={field.id} align="left" sx={{ ...baseStyle, whiteSpace: 'nowrap' }}>
                <GridTruncatedText>{text}</GridTruncatedText>
            </TableCell>
        );
    }
}
